import style from './ManagePackModal.module.css';

import { useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import Modal from 'ui/Modal';
import FormTextField from 'ui/formItems/FormTextField';
import useAlert from 'hooks/useAlert';
import { editPack } from 'services/pucks.services';

const ManagePackModal = ({ id, open, onClose, data = undefined }) => {
  const { showAlert } = useAlert();
  const [loading, setLoading] = useState(false);

  const formContext = useForm({
    defaultValues: {
      name: data?.name || '',
    },
  });

  const { handleSubmit } = formContext;

  const onSubmit = async (formData) => {
    setLoading(true);
    const payload = {
      id: id,
      type: data.type,
      name: formData.name,
    };

    const action = async () => {
      const res = await editPack(payload);
      if (res.success) {
        successCangeNameAlert();
        onClose({ open: false, item: res.result });
      } else {
        if (res.error_code) errorCommonAlert(res.error_code);
      }
    };
    sureChangeNameAlert(action);
    setLoading(false);
  };

  const successCangeNameAlert = () => showAlert('Наименование штатива обновлено!', 'success');

  const errorCommonAlert = (error_code) =>
    showAlert(
      `Код ${error_code} Редактирование невозможно! Штатив привязан или имеет образцы!`,
      'error',
    );

  const sureChangeNameAlert = (callback) =>
    showAlert('Изменить наименование штатива?', 'sure', callback);

  return (
    <FormProvider {...formContext}>
      <Modal
        title="Редактирование штатива"
        open={open}
        onClose={() => onClose({ open: false, item: null })}
        onSubmit={handleSubmit(onSubmit)}
        submitText="Сохранить"
        disabledSubmit={loading}
      >
        <FormTextField
          className={style.textField}
          name="name"
          label="Наименование"
          required
          rules={{ required: 'Поле обязательно' }}
        />
      </Modal>
    </FormProvider>
  );
};

export default ManagePackModal;
